import { render, staticRenderFns } from "./StudentCurrentObjective.vue?vue&type=template&id=019501d3&scoped=true&lang=pug&"
import script from "./StudentCurrentObjective.vue?vue&type=script&lang=ts&"
export * from "./StudentCurrentObjective.vue?vue&type=script&lang=ts&"
import style0 from "./StudentCurrentObjective.vue?vue&type=style&index=0&id=019501d3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019501d3",
  null
  
)

export default component.exports